import { useVideoPromotionStore } from '../../../../stores/useVideoPromotionStore'
import { CopyVideosSelection } from '../CopyVideosSelection'

export const PromotionCopyInfoCards = () => {
  const videoPromotionStore = useVideoPromotionStore()

  return (
    <CopyVideosSelection
      value={videoPromotionStore.elementsConfiguration.infoCards.copySource}
      onChange={source => videoPromotionStore.setElementCopySource('infoCards', source)}
    />
  )
}
